<template>
    <el-container>
        <el-header>
            <v-header/>
        </el-header>
        <el-container >
            <el-aside width="256px">
                <v-aside/>
            </el-aside>
            <el-main>
                <router-view/>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import vHeader from '@/views/common/header.vue'
import vAside from '@/views/common/aside.vue'
export default {
    name:'home',
    data() {
        return {

        }
    },
    components:{
        vHeader,vAside
    }
}
</script>
<style scoped>
    .el-container.is-vertical{
        width: 100%;
        height:100%;
        overflow: hidden;
    }

    .el-container.is-vertical .el-container{
        overflow: hidden;
    }

    .el-header{
        background-color: #2372EA;
        color: #FFFFFF;
    }

    .el-aside{
        background: #001529;
        color: #FFFFFF;
        overflow: hidden;
    }

    .el-main{
        background: #F0F2F5;
        padding: 0;
        overflow: hidden;
        
    }
</style>






// WEBPACK FOOTER //
// src/views/home.vue